export function countDuplicateEnglishTranscripts(transcripts) {
  const seen = new Set();
  let count = 0;
  for (const t of transcripts) {
    const key = `${(t.timeframe || '').trim()}|${(t.original_text || '').trim()}`;
    if (seen.has(key)) count++;
    else seen.add(key);
  }
  return count;
}
